import { render, staticRenderFns } from "./BaseCountry.vue?vue&type=template&id=8891af5a&"
import script from "./BaseCountry.vue?vue&type=script&lang=ts&"
export * from "./BaseCountry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports